import {decode} from './decode';
import {take, put, select, delay} from 'redux-saga/effects';
import {settings, session, googleCalendar} from 'store';
import {set} from 'store/settings';

export function* update() {
  while (yield take(['APP_DATA_CHANGED', 'GOOGLE_CALENDAR_SUCCESSFUL_CHANGE', 'GOOGLE_CALENDAR_ERROR', 'ACTIVITIES_DELETE'])) {

    const { changes } = yield select(googleCalendar.settings);

    for (const change of changes) {
      try {
        //wait a bit to not exceed google api rate
        yield delay(100);
        const payload = {};
        switch (change.action) {
          case 'create': {
            const { result } = yield window.gapi.client.calendar.events.insert(change.payload);
            payload.event = {
              ...decode(result),
              googleCalendarId: change.payload.calendarId,
            }
            break;
          }

          case 'update': {
            const { result } = yield window.gapi.client.calendar.events.patch(change.payload);
            payload.event = {
              ...decode(result),
              googleCalendarId: change.payload.calendarId,
            }
            break;
          }

          case 'move': {
            yield window.gapi.client.calendar.events.move(change.payload);
            break;
          }

          case 'delete': {
            yield window.gapi.client.calendar.events.delete(change.payload);
            break;
          }
        }

        yield put({
          type: 'GOOGLE_CALENDAR_SUCCESSFUL_CHANGE',
          change,
          ...payload,
        });
      } catch (error) {
        yield put({
          ...error.result,
          type: 'GOOGLE_CALENDAR_ERROR',
          change,
        });
      }
    }
  }
}

export function* updateSettings() {
  const { email } = yield select(session.user);
  const { googleSyncEnabled } = yield select(settings.settings);
  if (email && !googleSyncEnabled) {
    set({
      key: 'googleSyncEnabled',
      value: 1,
    });
  }
}
